import React from 'react';

const XI_BOT_AVATAR_SRC = '/assets/mascot/xi-mascot-home.png';

export default function XiBotAvatar({ size = 'md', className = '', alt = '' }) {
  return (
    <span className={`xi-bot-avatar xi-bot-avatar--${size} ${className}`.trim()}>
      <img src={XI_BOT_AVATAR_SRC} alt={alt} draggable={false} decoding="async" />
    </span>
  );
}
